<script>
  import SectionRenderer from '../components/SectionRenderer.vue';
  import sections from './sections.json';
  import HashChangeListenerMixin from '@/views/app/dashboard/footer-pages/components/HashChangeListenerMixin';
  export default {
    name: 'Crypto',
    components: { SectionRenderer },
    mixins: [HashChangeListenerMixin(sections, [...sections.qa[0].children, ...sections.advantages[0].children])],
    data: () => ({
      isScrolling: false,
    }),
    metaInfo() {
      return {
        title: 'Crypto',
        meta: [
          {
            name: 'robots',
            content: 'noindex, nofollow',
          },
        ],
      };
    },
    computed: {
      qaIndex() {
        if (this.activeSectionIndex > this.sections.qa[0].children.length - 1) return null;
        return this.activeSectionIndex;
      },
      advantagesIndex() {
        const qaLength = this.sections.qa[0].children.length;
        if (this.activeSectionIndex > qaLength - 1) return this.activeSectionIndex - qaLength;
        return null;
      },
    },
  };
</script>
<template>
  <div class="page-container">
    <div class="page">
      <div class="content">
        <h1 class="mb-8">CRYPTO</h1>
        <span class="white--text mb-6 d-block">
          MaxQuest is 100% crypto-powered, offering players a cutting-edge gaming experience and premier security. If
          you're new to cryptocurrencies, we'll get you up to speed.
        </span>
        <img class="hide--mobile" src="/images/crypto/MQ-Crypto-Banner-desktop.webp?v=3" alt="Crypto" />
        <img class="hide--desktop w-100" src="/images/crypto/MQ-Crypto-Banner-mobile.webp?v=3" alt="Crypto" />
        <h2 class="mt-15">Quick Q&A</h2>
        <section-renderer
          class="mt-6"
          :sections="sections.qa"
          @click="handleSectionClick"
          :active-section-index="qaIndex"
        />
        <h2>Advantages of Cryptocurrencies</h2>
        <section-renderer
          class="mt-6"
          :sections="sections.advantages"
          @click="handleSectionClick"
          :active-section-index="advantagesIndex"
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import '../components/style.scss';
  ::v-deep .content {
    h2 {
      font-size: 40px !important;
    }
    ol li:before {
      content: unset;
    }
  }
</style>
